import { formatCurrency } from "../../../../../Utils/utils"
import { STATUS_LABELS } from "../../AllPage/constants/statusMeta"

// One uniform status block for every lifecycle state: tone (drives the dot
// colour), a title, and a one-line explanation. The TITLE is always the exact
// table label (STATUS_LABELS, the shared source of truth in statusMeta.js), so
// the page never disagrees with the table ("Won" here used to read "Recovered");
// the amounts / fees / escalation details live in the sub-line instead.
export const buildStatusInfo = ({
  status,
  escalated,
  stageLabel,
  commissionCharge,
  recoveredAmount,
  commissionAmount,
  t
}) => {
  const title = t(STATUS_LABELS[status] || STATUS_LABELS.needs_response)
  // A re-opened (pre-arbitration / arbitration) dispute that's actionable again:
  // same status title as the table, the escalation urgency moves to the sub-line.
  if (escalated && (status === "needs_response" || status === "awaiting_review")) {
    return {
      tone: "warning",
      title,
      sub: t(
        "_stage_: the issuer escalated this dispute after the first round. Review and submit your evidence again before the deadline.",
        { stage: stageLabel }
      )
    }
  }
  switch (status) {
    case "won":
      return {
        tone: "success",
        title,
        sub: commissionCharge
          ? t("Recovered _amount_. Our 25% fee of _fee_ has been billed.", {
              amount: formatCurrency(recoveredAmount),
              fee: formatCurrency(commissionAmount)
            })
          : t("Recovered _amount_. Our 25% fee will be billed once the issuer settles.", {
              amount: formatCurrency(recoveredAmount)
            })
      }
    case "lost_defended":
      return { tone: "danger", title, sub: t("No fee was charged.") }
    case "lost_undefended":
      return {
        tone: "danger",
        title,
        sub: t("The response deadline passed with no evidence submitted. No fee was charged.")
      }
    case "escalated":
      return {
        tone: "warning",
        title,
        sub: t(
          "The inquiry was not resolved and the issuer is turning it into a formal dispute. It will come back as a new chargeback."
        )
      }
    case "pending_decision":
      return {
        tone: "info",
        title,
        sub: escalated
          ? t("Evidence was submitted. Waiting on the issuer’s _stage_ decision.", {
              stage: stageLabel.toLowerCase()
            })
          : t("Evidence was submitted. Waiting on the issuer to decide.")
      }
    case "skipped":
      return { tone: "neutral", title, sub: t("No evidence was submitted.") }
    case "needs_response":
    case "awaiting_review":
    default:
      return {
        tone: "info",
        title,
        sub:
          commissionAmount > 0
            ? t("On a win you would owe _amount_ (25% fee).", {
                amount: formatCurrency(commissionAmount)
              })
            : t("Review the evidence and approve to submit on your behalf.")
      }
  }
}
